import BaseRepository from '@/repositories/base/BaseRepository'

class ExtensionRepository extends BaseRepository {
	getCpcGeneral(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/wallet/getCpcGeneral',
			data: params,
		})
	}
	getCpcAdOrder(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/cpcAd/getCpcAdOrder',
			data: params,
		})
	}
	getCompaginList(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/flowExpress/getCompaginList',
			data: params,
		})
	}

	getCampaignExtendData(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/flowExpress/getCampaignExtendData',
			data: params,
		})
	}

	getCompaginButtonDisplay(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/flowExpress/getCompaginButtonDisplay',
			data: params,
		})
	}
	getJournalDetail(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/cpcAd/getJournalDetail',
			data: params,
		})
	}
	cpcStatusChange(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/cpcAd/cpcStatusChange',
			data: params,
		})
	}
	/**推广中心 */

	noticeCenterList(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/noticeCenter/list',
			data: params,
		})
	}
	getRechargeRedPacketList(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/flowExpress/getRechargeRedPacketList',
			data: params,
		})
	}
	getDiagnosisInfo(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/guidance/getDiagnosisInfo',
			data: params,
		})
	}
	getDiagnosisFlow(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/guidance/getDiagnosisFlow',
			data: params,
		})
	}
	getHotelBindingNotice(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/flowExpress/getHotelBindingNotice',
			data: params,
		})
	}

	getAccountInfo(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/wallet/getAccountInfo',
			data: params,
		})
	}
	getAgencyCashRedPacketRatio(params: any) {
		return this.get<any>({
			url: '/ebk-dkb-api/agency-info/get-agency-cash-red-packet-ratio',
			data: params,
		})
	}

	// 获取创建推广计划默认数据
	cpcTrafficCarCreate(params: any) {
		return this.get<any>({
			url: '/ebk-dkb-api/extension/cpcTrafficCarCreate',
			data: params,
		})
	}

	// 获取活动类型
	getActivityKinds(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/goldBooth/getActivityKinds',
			data: params,
		})
	}

	// 获取酒店、推广计划高峰日设置
	getHotelCampaignPeakDay(params: any) {
		return this.get<any>({
			url: '/ebk-dkb-api/extension/hotel-campaign-peak-day',
			data: params,
		})
	}

	// 成单前校验
	beforeCreateCheck(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/extension/beforeCreateCheck',
			data: params,
		})
	}

	// 创建推广
	createPromotion(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/extension/create',
			data: params,
		})
	}

	// 修改推广
	modifyPromotion(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/extension/modify',
			data: params,
		})
	}

	// 获取建议出价
	getCpsSuggestBid(params: any) {
		return this.get<any>({
			url: '/ebk-dkb-api/extension/cps-suggest-bid',
			data: params,
		})
	}

	// 获取cps预估出价
	getCpsEstimatedCost(params: any) {
		return this.get<any>({
			url: '/ebk-dkb-api/extension/cps-estimated-cost',
			data: params,
		})
	}

	// 推广计划详情
	getCpcAdDetail(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/cpcAd/getCpcAdDetail',
			data: params,
		})
	}

	// 查看旺季高峰日
	getHotelPeakDayCalendar(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/extension/get-hotel-peak-day-calendar',
			data: params,
		})
	}
	//获取订阅消息配置
	getSubscribe(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/subscribe/getSubscribe',
			data: params,
		})
	}

	//获取初始订阅提醒信息
	getStartSubscribe(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/subscribe/getStartSubscribe',
			data: params,
		})
	}

	//新增订阅提醒配置
	addSubscribe(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/subscribe/addSubscribe',
			data: params,
		})
	}

	//更新订阅消息配置
	updateSubscribe(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/subscribe/updateSubscribe',
			data: params,
		})
	}
	
	// 效果数据订单明细
	getCampaignAdOrderDetail(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/flowExpress/campaign-ad-order-detail',
			data: params,
		})
	}

	// 效果数据订单明细
	getHotelCampaignInsuranceConfig() {
		return this.get<any>({
			url: '/ebk-dkb-api/cpcAd/get-hotel-campaign-insurance-config',
			data: {},
		})
	}

	/** 保效计划考核是否已完成：true 表示尚未完成考核（未完成考核时提前删除有特殊提示） */
	getCpcAdAssessmentCompleted(params: { orderSerialId: string }) {
		return this.get<any>({
			url: '/ebk-dkb-api/cpcAd/is-within-assessment-period',
			data: params,
		})
	}

	/** 场景出价新老页面开关：true 打开新页，false 关闭 */
	getScenarioBidNewPageSwitch() {
		return this.get<boolean>({
			url: '/ebk-dkb-api/config/get-scenario-bid-new-page-switch',
			data: {},
		})
	}
	
}

export default ExtensionRepository
